import Navbar from "@/components/marketing/Navbar";
import Hero from "@/components/marketing/Hero";
import RecentWinsTicker from "@/components/marketing/RecentWinsTicker";
import TopWinners from "@/components/marketing/TopWinners";
import ArcadeShowcase from "@/components/marketing/ArcadeShowcase";
import LiveTicker from "@/components/marketing/LiveTicker";
import LivePayouts from "@/components/marketing/LivePayouts";
import Markets from "@/components/marketing/Markets";
import HowItWorks from "@/components/marketing/HowItWorks";
import Platforms from "@/components/marketing/Platforms";
import LiveMarkets from "@/components/marketing/LiveMarkets";
import WhyVts from "@/components/marketing/WhyVts";
import FAQ from "@/components/marketing/FAQ";
import CTASection from "@/components/marketing/CTASection";
import Footer from "@/components/marketing/Footer";
import NewUserWelcomeDialog from "@/components/marketing/NewUserWelcomeDialog";
import TelegramInvitePopup from "@/components/marketing/TelegramInvitePopup";

const Landing = () => {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-vts-bg">
      <Navbar />
      <main>
        <Hero />
        <section data-testid="social-proof-row" className="relative py-10 px-4 sm:px-8 bg-[#0B0E14]">
          <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-8 items-stretch">
            <RecentWinsTicker />
            <TopWinners />
          </div>
        </section>
        <ArcadeShowcase />
        <LiveTicker />
        <LivePayouts />
        <Markets />
        <HowItWorks />
        <Platforms />
        <LiveMarkets />
        <WhyVts />
        <FAQ />
        <CTASection />
      </main>
      <Footer />
      <NewUserWelcomeDialog />
      <TelegramInvitePopup />
    </div>
  );
};

export default Landing;
